import { Component, OnDestroy, OnInit } from '@angular/core';
import { SaveStatusRequest, SaveStatusService } from '../save-status.service';
import { LocalizationService } from '../../services/localization.service';

@Component({
    selector: 'app-pg-save-status',
    templateUrl: './pg-save-status.component.html',
    styleUrls: ['./pg-save-status.component.scss'],
    standalone: false
})
export class PgSaveStatusComponent implements OnInit, OnDestroy {

    constructor(private saveStatusService:SaveStatusService, private localizationService:LocalizationService) { }

    requests:Array<SaveStatusRequest> = null;

    availableLanguages:Array<string> = null;

    ngOnInit(): void {
        this.requests = this.saveStatusService.addListener();
        this.availableLanguages = this.localizationService.availableApplicationLanguages
    }

    ngOnDestroy(): void {
        this.saveStatusService.removeListener();
    }

    hasAction(request:SaveStatusRequest, name:string) {
        return request.actions[name] != null;
    }

    isActionDisabled(request:SaveStatusRequest, name:string) {
        return request.disabled || request.status == 'running' || !request.actions[name];
    }

    hasToggle(request:SaveStatusRequest, name:string) {
        return request.toggles[name] != null;
    }

    isToggleDisabled(request:SaveStatusRequest, name:string) {
        return request.disabled || request.status == 'running' || !request.toggles[name];
    }

    hasLanguages(request:SaveStatusRequest) {
        return request.languages != null;
    }
}
